import React from 'react'
import { subYears, eachYearOfInterval, format, startOfWeek, previousMonday, addWeeks } from 'date-fns'
import { SelectBox } from 'components/formFields/SelectBox'

const getYears = (offsetWeeks?: number) => {
  const today = new Date()
  const currentMonday = startOfWeek(today, { weekStartsOn: 1 })
  const prevMonday = previousMonday(currentMonday)
  const twoYearsAgo = subYears(currentMonday, 2)

  const offsetMonday = offsetWeeks ? startOfWeek(addWeeks(twoYearsAgo, offsetWeeks), { weekStartsOn: 1 }) : undefined

  const yearsDateArray = eachYearOfInterval({
    start: offsetMonday ?? twoYearsAgo,
    end: offsetMonday ? prevMonday : currentMonday,
  })

  return yearsDateArray.reverse()
}

type SelectYearProps = {
  disabled?: boolean
  offsetWeeks?: number
  searchState: {
    year: string
  }
  handleYearChange(selectedYear: string): void
}

export const SelectYear = (props: SelectYearProps) => {
  const { disabled, offsetWeeks, searchState, handleYearChange } = props
  const { year } = searchState

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (validation: boolean = false) => {
    if (!year) {
      if (fieldError) return true
      else if (validation) setFieldError('triggered')
    }
    return false
  }

  return (
    <div className="w-full sm:w-64">
      <SelectBox
        placeholder="Select year"
        label="Year *"
        id="year"
        value={year}
        disabled={disabled}
        onChange={(value) => handleYearChange(value)}
        options={(getYears(offsetWeeks) || []).map((item) => ({
          text: format(item, 'yyyy'),
          value: format(item, 'yyyy'),
        }))}
        onBlur={() => validateField(true)}
        error={!!validateField()}
      />
    </div>
  )
}
